import { render, staticRenderFns } from "./RegistroActividadDetalle.vue?vue&type=template&id=c6b1ee4e&"
import script from "./RegistroActividadDetalle.vue?vue&type=script&lang=js&"
export * from "./RegistroActividadDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports